import { jwtDecode } from "jwt-decode";

export function checkTokenValidity() {
  const token = localStorage.getItem("token");
  if (!token) return { valid: false, reason: "Please login first" };

  try {
    // handle both "Bearer <token>" and "<token>"
    const jwt = token.startsWith("Bearer ") ? token.split(" ")[1] : token;
    const decoded = jwtDecode(jwt);

    if (!decoded.exp) return { valid: false, reason: "Invalid token" };

    const isExpired = decoded.exp * 1000 < Date.now();
    if (isExpired) {
      return { valid: false, reason: "Session expired, please login again" };
    }

    return { valid: true };
  } catch (err) {
    console.error("Invalid token:", err);
    return { valid: false, reason: "Invalid token" };
  }
}

export function isLoggedIn() {
  const { valid } = checkTokenValidity();
  return valid;
}

export function getMenusFromToken() {
  const token = localStorage.getItem("token");
  if (!token) return [];

  try {
    const jwt = token.split(" ")[1]; // remove "Bearer"
    const decoded = jwtDecode(jwt);

    // If backend sends menus in claim
    return ["Dashboard", ...decoded.permissions] || [];
  } catch (err) {
    console.error("Failed to decode token:", err);
    return [];
  }
}

export function getToken() {
  return localStorage.getItem("token"); // or cookie read helper
}

export function decodeToken() {
  const token = getToken();
  if (!token) return null;
  try {
    const jwt = token.split(" ")[1];
    return jwtDecode(jwt);
  } catch (e) {
    return null;
  }
}

export function getPermissions() {
  const decoded = decodeToken();
  return (decoded && decoded.menus) || (decoded && decoded.permissions) || [];
}

export function hasPermission(required) {
  const perms = getPermissions();
  console.log("perms: " + perms);
  console.log("required: " + required);
  // required can be string or array
  if (!required) return true;
  if (Array.isArray(required)) {
    return required.some((r) => perms.includes(r));
  }
  return perms.includes(required);
}
